module.exports = __webpack_public_path__ + "img/logo.0b3f5c2b.png";